import React, { ReactNode } from 'react'
import styleIcon from './Modal.module.scss'

interface ModalProps {
  handleClose?: () => void
  dialogStyle?: React.CSSProperties
  contentStyle?: React.CSSProperties
  children?: ReactNode
}

export const Modal = ({ handleClose, dialogStyle = {}, contentStyle = {}, children }: ModalProps): JSX.Element => {
  return (
    <div className={styleIcon.Modal}>
      <i />
      <div
        className={styleIcon.Modal__mask}
        onClick={!!handleClose && (() => { handleClose() })}
      />
      <div className={styleIcon.Modal__dialog}
           style={dialogStyle && dialogStyle}
      >
          <div
            className={styleIcon.Modal__content}
            style={contentStyle && contentStyle}
          >
            <div className={styleIcon.Modal__body}>
              {children && children}
            </div>
          </div>
        </div>
      <i />
    </div>
  )
}
